export default function TenantReducer(state = { Tenant: "Sierra" }, action) {

    switch (action.type) {
        case "SET_TENANT":
            return { ...state, Tenant: action.payload }
        default:
            return state
    }
}